<template>
  <v-app :class="{ 'vendedora-app': esRutaVendedora, 'pantalla-azul': esPantallaAzul }">
    
    <!-- Header  -->
    <v-app-bar 
      app 
      color="white" 
      v-if="mostrarChromeLms && getLogeadoLMS && getUsuarioLMS && getUsuarioLMS.roll == 'EDITOR'" 
      class ="ma-2 mt-2" 
      style="border-radius: 10px;"
    >
      <v-app-bar-nav-icon @click="drawer = true"></v-app-bar-nav-icon>
      <v-toolbar-title></v-toolbar-title>
    </v-app-bar>

    <!-- Drawer  -->
    <v-navigation-drawer
      v-model="drawer"
      app
      v-if="mostrarChromeLms && getLogeadoLMS && getUsuarioLMS && getUsuarioLMS.roll == 'EDITOR'"
      class="elevation-3 mt-3 pb-5"
      style="border-radius: 10px;"
    >
      <v-list
        nav
        dense
      >
        <v-list-item-group
          v-model="selectedItem"
          color="primary"
        >
          <v-list-item
            v-for="(item, i) in menu"
            :key="i"
            :to="{ name: item.path}"
            exact
          >
            <v-list-item-icon>
              <v-icon v-text="item.icon"></v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title v-text="item.text"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <!-- Contenido  -->
    <v-main :class="{ 'vendedora-main': esRutaVendedora }">
      <router-view/>
    </v-main>

    <!-- Footer  -->
    <v-footer app class="pa-0" v-if="mostrarChromeLms && getLogeadoLMS">
      <Navegador/>
    </v-footer>

    <NoInternet v-if="!estatusInternet && mostrarChromeLms"/>
    <BloqueoCiclo/>

    <!-- PushNotifications
    <v-snackbar
      v-model="notificacionExamenUbicacion.visible"
      top
      left
      :timeout="8000"
      color="#388e3c"
      class="notificacion-examen-ubicacion"
      @click="abrirChatExamenUbicacion"
    >
      <div class="notificacion-examen-ubicacion__contenido">
        <div class="notificacion-examen-ubicacion__titulo">
          {{ notificacionExamenUbicacion.titulo }}
        </div>
        <div class="notificacion-examen-ubicacion__mensaje">
          {{ notificacionExamenUbicacion.mensaje }}
        </div>
      </div>
    </v-snackbar>
    -->

    <svg xmlns="http://www.w3.org/2000/svg" style="display: none;">
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7 4" id="eye">
        <path d="M1,1 C1.59223333,1.64257813 2.42556667,2.14257813 3.5,2.5 C2.42556667,2.85742188 1.59223333,3.35742188 1,4 C-0.333333333,2.66666667 -0.333333333,1.33333333 1,1 Z" transform="translate(3.000000, 2.000000) scale(-1, 1) translate(-3.000000, -2.000000) "></path>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 5 5" id="iris">
        <circle cx="2.5" cy="2.5" r="2.5"></circle>
      </symbol>
    </svg>
  </v-app>
</template>

<script>
  // import { PushNotifications } from '@capacitor/push-notifications';
  // import { Capacitor } from '@capacitor/core';
  // Componentes
  import { Device } from '@capacitor/device';

  // Componentes
  import Navegador  from '@/components/Navegador.vue'
  import NoInternet from '@/components/alertas/NoInternet.vue'
  import BloqueoCiclo from '@/components/alertas/BloqueoCiclo.vue'

  // Librerías y más
  import { mapGetters, mapActions } from 'vuex'

  // Capacitor
  import { Network } from '@capacitor/network';
  import { limpiarPersistenciaVendedoraLegacy, limpiarSoloLegacyCapacitor } from '@/utils/sesionVendedora'

  export default {
    components:{
      Navegador,
      NoInternet,
      BloqueoCiclo,
    },

    name: 'App',

    data: () => ({
      drawer: false,
      drawer2:false,
      mini:false,
      escuela:1,
      color_active:'',
      estatusInternet: true,
      tokejs:'',
      notificacionExamenUbicacion: {
        visible: false,
        titulo: '',
        mensaje: ''
      },
      selectedItem: null,

      menu: [
        { text: 'Ni por vendedora'   , icon: 'mdi-circle-medium' , path: 'NiVendedora'      },
        { text: 'Tickets'            , icon: 'mdi-circle-medium' , path: 'TicketsEditor'    },
        { text: 'Kpi general'        , icon: 'mdi-circle-medium' , path: 'KPIGeneral'       },
        { text: 'Kpi Montos'         , icon: 'mdi-circle-medium' , path: 'KPIMontos'        },
        { text: 'Rep. Semanal Ventas', icon: 'mdi-circle-medium' , path: 'RepSemanalVentas' },
        { text: 'Requisiciones'      , icon: 'mdi-circle-medium' , path: 'Requisiciones'    },
      ],
    }),

    async created ( ){
      // this.registrarNotificacionExamenUbicacion()
      await limpiarSoloLegacyCapacitor()

      const hash = (window.location.hash || '').toLowerCase()
      if (hash.includes('vendedora-acceso') || hash.includes('modo_vendedora')) {
        await limpiarPersistenciaVendedoraLegacy()
        this.$router.replace({ name: 'Login' }).catch(() => {})
        return
      }

      if( this.getUsuarioLMS ){
        // Actualizar el tipo de dispositivo, esto es para poder recibir notificaciones
        const info = await Device.getInfo();

        const payload = { id: this.getUsuarioLMS.id, dispositivo: info.operatingSystem }
        this.$http.post('usuario.tipodispositivo', payload).then( response => {
          this.cargar = false
        }).catch( error => {
          this.cargar = false
          if( error.status == 400 || error.status == 500){
            this.parametros.mensaje      = error.body.message
            this.parametros.dialogError  = true 
            this.parametros.color        = '#FF2C2C' 
            this.respuestaAlerta         = true 
          }
        }).finally(()=>{ this.cargar = false })
      }

      try {
        Network.addListener('networkStatusChange', status => {
          this.estatusInternet = status.connected ;
        });

        const status = await Network.getStatus();
        this.estatusInternet = status.connected ;
      } catch (e) {
        this.estatusInternet = true
      }
    },


    methods:{
      ...mapActions( 'login', [ 'salirLogin' ]),

      salir(){
        this.salirLogin()
      },

      // registrarNotificacionExamenUbicacion(){
      //   if (!Capacitor.isNativePlatform()) return
      //
      //   PushNotifications.addListener('pushNotificationReceived', notification => {
      //     if (!this.esNotificacionExamenUbicacion(notification)) return
      //     this.mostrarNotificacionExamenUbicacion(notification)
      //   })
      // },
      //
      // esNotificacionExamenUbicacion(notification){
      //   const titulo = this.normalizarTexto(
      //     notification && (notification.title || notification.data?.title || notification.data?.titulo)
      //   )
      //
      //   return titulo.includes('examen de ubicacion')
      // },
      //
      // mostrarNotificacionExamenUbicacion(notification){
      //   this.notificacionExamenUbicacion.titulo = notification.title || notification.data?.title || 'Examen de ubicación'
      //   this.notificacionExamenUbicacion.mensaje = notification.body || notification.data?.body || notification.data?.mensaje || ''
      //   this.notificacionExamenUbicacion.visible = true
      // },
      //
      // abrirChatExamenUbicacion(){
      //   this.notificacionExamenUbicacion.visible = false
      //   if (this.$route.name === 'TwilioVentas') return
      //
      //   this.$router.push({ name: 'TwilioVentas' }).catch(() => {})
      // },

      normalizarTexto(value){
        return String(value || '')
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .toLowerCase()
      },
      
    },

    computed:{
      ...mapGetters( 'login', [ 'getUsuarioLMS', 'getLogeadoLMS', 'getDatosUsuarioLMS' ]),

      menu( ){
        if( this.getUsuarioLMS.id == 19638 ){
          return [
            { text: 'Actividades Diarias Todos'   , icon: 'mdi-circle-medium' , path: 'ActividadesDiariasTodos'      },
          ]
        }else{
          return [
            { text: 'Ni por vendedora'   , icon: 'mdi-circle-medium' , path: 'NiVendedora'      },
            { text: 'Tickets'            , icon: 'mdi-circle-medium' , path: 'TicketsEditor'    },
            { text: 'Kpi general'        , icon: 'mdi-circle-medium' , path: 'KPIGeneral'       },
            { text: 'Kpi Montos'         , icon: 'mdi-circle-medium' , path: 'KPIMontos'        },
            { text: 'Rep. Semanal Ventas', icon: 'mdi-circle-medium' , path: 'RepSemanalVentas' },
            { text: 'Requisiciones'      , icon: 'mdi-circle-medium' , path: 'Requisiciones'    },
          ]
        }

      },
      esRutaVendedora () {
        const p = this.$route && this.$route.path
        return !!(p && String(p).startsWith('/vendedora'))
      },

      esPantallaAzul () {
        const name = this.$route && this.$route.name
        return name === 'Carga' || name === 'Login'
      },

      mostrarChromeLms () {
        return !this.esRutaVendedora
      },
    },

    watch: {
      esRutaVendedora: {
        immediate: true,
        handler (v) {
          if (typeof document === 'undefined') return
          document.documentElement.classList.toggle('vendedora-lock', !!v)
          document.body.classList.toggle('vendedora-lock', !!v)
        },
      },
      esPantallaAzul: {
        immediate: true,
        handler (v) {
          if (typeof document === 'undefined') return
          document.documentElement.classList.toggle('pantalla-azul', !!v)
          document.body.classList.toggle('pantalla-azul', !!v)
        },
      },
    },

    beforeDestroy () {
      if (typeof document !== 'undefined') {
        document.documentElement.classList.remove('vendedora-lock')
        document.body.classList.remove('vendedora-lock')
        document.documentElement.classList.remove('pantalla-azul')
        document.body.classList.remove('pantalla-azul')
      }
    },
  };
</script>

<style>

  /* Vuetify fuerza overflow-y:scroll y deja franja clara a la derecha en macOS */
  html {
    overflow-x: hidden !important;
    overflow-y: auto !important;
    width: 100%;
    max-width: 100%;
  }

  html, body, #app {
    max-width: 100%;
    margin: 0;
    padding: 0;
  }

  body, #app {
    overflow-x: hidden;
    width: 100%;
  }

  .v-application,
  .v-application--wrap {
    max-width: 100% !important;
    width: 100% !important;
    overflow-x: hidden !important;
  }

  .v-application {
    background-color: #f8f9fa !important;
  }

  .v-main__wrap{
    background: #f8f9fa !important;
  }

  /* Carga / Login: ningún ancestro puede mostrar blanco/gris a los lados */
  html.pantalla-azul,
  html.pantalla-azul body,
  html.pantalla-azul #app,
  .pantalla-azul.v-application,
  .pantalla-azul .v-application--wrap,
  .pantalla-azul .v-main,
  .pantalla-azul .v-main__wrap {
    background: #46CFFF !important;
    background-color: #46CFFF !important;
    overflow-x: hidden !important;
  }

  html.pantalla-azul {
    overflow: hidden !important;
  }

  .v-application--is-ltr .v-list-item__icon:first-child{
    margin-right: 10px !important;
  }

  .v-list--nav .v-list-item, .v-list--rounded .v-list-item{
    padding: 0 8px !important;
  }

html.vendedora-lock,
html.vendedora-lock body,
html.vendedora-lock #app {
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 100vh;
  max-height: 100dvh;
  overflow: hidden !important;
  overscroll-behavior: none;
  background: #f0f2f5;
}
.vendedora-app.v-application,
.vendedora-app .v-application--wrap {
  width: 100% !important;
  height: 100% !important;
  min-height: 0 !important;
  max-height: 100% !important;
  overflow: hidden !important;
}
.vendedora-main.v-main {
  padding: 0 !important;
  flex: 1 1 0% !important;
  width: 100% !important;
  height: 100% !important;
  min-height: 0 !important;
  max-height: 100% !important;
  overflow: hidden !important;
}
.vendedora-main .v-main__wrap {
  height: 100% !important;
  min-height: 0 !important;
  max-height: 100% !important;
  overflow: hidden !important;
  background: transparent !important;
}

  .v-list--nav.v-list-item, .v-list--nav .v-list-item:before, .v-list--rounded.v-list-item, .v-list--rounded .v-list-item:before{
    border-radius: inherit !important;
  }

  .v-list-item__title{
    white-space: inherit !important;
  }

  .theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
    color: #000000 !important;
  }

  .v-list-item__action {
    min-width: 0px !important;
    justify-content: flex-end;
  }

  .notificacion-examen-ubicacion {
    left: 12px !important;
    right: 12px !important;
    width: auto !important;
    max-width: none !important;
    margin: 0 !important;
  }

  .notificacion-examen-ubicacion .v-snack__wrapper {
    margin: 0 !important;
  }

  .notificacion-examen-ubicacion .v-snack__content {
    color: #fff !important;
    padding: 14px 18px !important;
  }

  .notificacion-examen-ubicacion__contenido {
    cursor: pointer;
    line-height: 1.35;
  }

  .notificacion-examen-ubicacion__titulo {
    color: #fff;
    font-weight: 700;
    margin-bottom: 6px;
  }

  .notificacion-examen-ubicacion__mensaje {
    color: #fff;
  }
</style>
